import React, { useEffect, useRef, CSSProperties, memo } from 'react';
import { BrowserJsPlumbInstance } from '@jsplumb/community';
import classNames from 'classnames';
import { GroupWidgetPort, Position } from '@kemu-io/kemu-core/types';
import { VIRTUAL_PORT_ELEMENT_CLASS, WIDGET_SELECTED_CLASS } from '../../common/constants';
import { generateDomId } from '../../common/utils';
import styles from './virtualPort.module.css';

interface Props {
	port: GroupWidgetPort;
	isInner: boolean;
	gateId: string;
	blockId: string;
	recipeId: string;
	plumbInstance: BrowserJsPlumbInstance;
	updatePortPosition: (port: GroupWidgetPort, position: Position) => void;
	portLocation: 'Right' | 'Left';
	isSelected?: boolean;
}


const getDefaultPosition = (portLocation: 'Right' | 'Left', index: number, position?: Position): Position => {
	if (position?.x !== undefined && position?.y !== undefined) { return position; }

	// Handle inputs
	if (portLocation === 'Right') {
		return {
			x: 100,
			y: 100 + (60 * index)
		};
	} else {
		return {
			x: 500,
			y: 100 + (60 * index)
		};
	}
};

const VirtualPort = (props: Props): React.JSX.Element => {
	const { gateId, port, portLocation, blockId, recipeId, updatePortPosition, isSelected } = props;
	const containerRef = useRef<HTMLDivElement | null>(null);
	const canvasDomId = generateDomId(recipeId, blockId, gateId, port.name);
	const position = getDefaultPosition(props.portLocation, port.index, port.position);
	const gatePos: CSSProperties= { left: position.x, top: position.y };
	const newPortPosStr = JSON.stringify(position);
	const currentPortPosStr = JSON.stringify(port.position);

	// We update the widget's state and set the default position if missing
	useEffect(() => {
		if (newPortPosStr !== currentPortPosStr) {
			updatePortPosition(port, JSON.parse(newPortPosStr));
		}
	}, [newPortPosStr, currentPortPosStr, port, updatePortPosition]);

	// console.log(`[:🧲 VirtualPort] - ${props.gateId} ${port.label || port.name}, ID: ${canvasDomId}`);
	return (
		<div
			className={classNames(styles.PortContainer, VIRTUAL_PORT_ELEMENT_CLASS, {
				[WIDGET_SELECTED_CLASS]: isSelected
			})}
			ref={containerRef}
			style={gatePos}
			id={canvasDomId}
		>
			{port.label || port.name}
		</div>
	);
};


export default memo(VirtualPort);
